import { useMutation, useQueryClient } from '@tanstack/react-query';
import { t } from 'i18next';
import { ENV_QUERY_KEY } from '../../../context/env-context';
import { useHandlers, useSite } from '../../../context/page-context';
import type { I18nPrefix } from '../../../i18n/prefix';
import { isServerError } from '../../../utils/errors';

const CARD =
  'features:storefront_widgets.pages.storefront_widgets_page.cards.sparkjs_version' satisfies I18nPrefix;

export function useUpdateSparkJsVersion() {
  const site = useSite();
  const { apis, notificationHandler } = useHandlers();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (version: string) => apis.sparkJs.updateVersion(site.siteId, site.siteEnv, version),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ENV_QUERY_KEY, site.siteId, site.siteEnv] });
      notificationHandler.notify(t('notifications:saved'), undefined, 'success');
    },
    onError: (error) => {
      if (isServerError(error)) {
        console.error('Failed to update SparkJS version', error);
        return;
      }
      notificationHandler.notify(t(`${CARD}.save_error`), undefined, 'error');
    },
  });
}
